<template>
  <div class="steps-new-template">
    <div v-if="!sent" class="steps-new-template-content">
      <a-steps :current="current" direction="vertical" class="steps">
        <a-step v-for="item in steps" :key="item.title" />
      </a-steps>
      <div class="steps-content">
        <div class="content">
          <h4 class="heading-h4">{{ title }}</h4>
          <a-form layout="vertical" :form="form">
            <template v-if="current === 0">
              <p class="body-2" style="white-space: pre-line">
                {{ descriptionFirstStep }}
              </p>
              <a-form-item label="Nombre de plantilla">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Este campo es requerido',
                        },
                        {
                          pattern: /^[a-z0-9_]+$/g,
                          message:
                            'El nombre debería ser en minúsculas separados por guión bajo, sin caracteres especiales',
                        },
                      ],
                    },
                  ]"
                  placeholder="Escribe aquí..."
                />
              </a-form-item>
            </template>
            <!---------------SEGUNDO PASO------------------------>
            <template v-else-if="current === 1">
              <p class="body-2">
                Este nombre será el que tus agentes visualizarán en
                {{ app }}.
              </p>
              <a-form-item label="Nombre de visualización">
                <a-input
                  v-decorator="[
                    'friendlyName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Este campo es requerido',
                        },
                      ],
                    },
                  ]"
                  placeholder="Escribe aquí..."
                />
              </a-form-item>
            </template>
            <!--------------------TERCER PASO------------------------->
            <template v-else-if="current === 2">
              <a-form-item label="Selecciona el idioma">
                <a-select
                  v-decorator="[
                    'lang',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Por favor completa este campo',
                        },
                      ],
                    },
                  ]"
                  placeholder="Selecciona aquí"
                >
                  <a-select-option value="es"> Español </a-select-option>
                  <a-select-option value="en"> Inglés </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <span slot="label">
                  Selecciona la categoría&nbsp;
                  <a-tooltip placement="right">
                    <template slot="title">
                      <a
                        href="https://www.securitec.pe/docs/ticker/whatsapp/plantillas-whatsapp/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Click aquí
                      </a>
                      para que sepas de que trata cada categoría.
                    </template>
                    <a-icon type="info-circle" />
                  </a-tooltip>
                </span>
                <a-select
                  v-decorator="[
                    'category',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Por favor completa este campo',
                        },
                      ],
                    },
                  ]"
                  placeholder="Selecciona aquí"
                >
                  <template v-for="category in categories">
                    <a-select-option :key="category">
                      {{ category }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </template>
            <!--------------------CUARTO PASO------------------------->
            <template v-else-if="current === 3">
              <a-alert
                v-if="validating"
                :message="`Hemos enviado un whatsapp a tu número ${profile.phone}, esto nos ayudará a verificar si tu plantilla está activa. Gracias`"
                type="info"
                show-icon
                style="margin-bottom: 4px"
              />
              <p v-else class="body-2">
                {{ descriptionFourStep }}
              </p>

              <a-form-item label="Contenido de plantilla">
                <a-input
                  v-decorator="[
                    'content',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Este campo es requerido',
                        },
                      ],
                    },
                  ]"
                  placeholder="Hola, tu código es de la plataforma"
                  type="textarea"
                  @input="typingContent"
                  :auto-size="{ minRows: 3, maxRows: 4 }"
                  :disabled="validating || sending"
                />
              </a-form-item>
              <Phone :message="message" />
            </template>
            <!--------------------QUINTO PASO------------------------->
            <template v-else-if="current === 4">
              <a-alert
                v-if="validating"
                :message="`Hemos enviado un whatsapp a tu número ${profile.phone}, esto nos ayudará a verificar si tu plantilla está activa. Gracias`"
                type="info"
                show-icon
                style="margin-bottom: 4px"
              />
              <template v-if="params.length">
                <custom-section-scroll
                  :master-styles="{
                    height: validating ? '224px' : '324px',
                  }"
                >
                  <template v-for="param in params">
                    <a-form-item
                      :label="`Nombre de parámetro ${param.title}`"
                      :key="`param-${param.title}`"
                    >
                      <a-input
                        v-decorator="[
                          `param-${param.title}`,
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Este campo es requerido',
                              },
                            ],
                          },
                        ]"
                        placeholder="Escribe aquí..."
                        :disabled="validating || sending"
                      />
                    </a-form-item>
                  </template>
                </custom-section-scroll>
              </template>
              <Phone v-if="params.length" :message="message" />
            </template>
          </a-form>
        </div>
        <div class="steps-action">
          <a-button
            @click="onClose"
            v-if="current === 0"
            style="min-width: 96px"
            >Cancelar</a-button
          >
          <a-button
            v-if="current > 0"
            @click="prev"
            style="min-width: 96px"
            :disabled="validating || sending"
            >Volver</a-button
          >
          <a-button
            v-if="current < steps.length - 1"
            @click="next"
            type="primary"
            :loading="loadButton"
            style="margin-left: 12px; min-width: 96px"
            :disabled="validating || sending"
            >{{ nameButton }}</a-button
          >
          <template v-else>
            <a-button
              v-if="current == steps.length - 1"
              type="primary"
              @click="openModalWarning(dataChannel.request)"
              style="margin-left: 12px; min-width: 96px"
              :disabled="validating || sending"
              >Continuar
            </a-button>
          </template>
        </div>
      </div>
    </div>
    <div v-else class="contain-sent">
      <svg
        width="273"
        height="149"
        viewBox="0 0 273 149"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.09542 30.0067C7.31798 27.9419 11.9108 26.6882 18.3559 27.4994C18.3559 27.4994 24.7249 7.48969 44.3648 15.1347C44.3648 15.1347 52.51 -5.61248 74.1799 3.532L75.7277 4.29404C82.0206 8.39922 84.6849 15.1347 84.6849 15.1347C104.299 7.46511 110.694 27.4994 110.694 27.4994C130.587 25.0412 132.617 42.0765 132.617 42.0765H7.85085C1.1266 42.0765 -1.53773 33.5957 4.09542 30.0067Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.1719 1.23859C54.2798 2.36295 50.9891 4.62762 48.2611 7.68783C46.8645 9.2546 45.7048 10.9307 44.7678 12.6073L44.6708 12.7825C44.4161 13.2461 44.1939 13.6825 44.0033 14.085L43.9542 14.1894L43.8927 14.1672C38.7503 12.3144 34.1869 12.2077 30.196 13.6066C26.7831 14.8029 23.9434 17.0383 21.6276 20.0019C20.386 21.5909 19.3732 23.2897 18.5702 24.9888L18.4871 25.1661C18.2693 25.6357 18.0808 26.0777 17.9205 26.4852L17.8385 26.6965L17.8348 26.6961C12.0191 26.069 7.31133 27.0628 3.67618 29.3921C-2.58172 33.3791 0.365759 42.8144 7.85156 42.8144H132.618C133.073 42.8144 133.427 42.4302 133.374 41.9923L133.36 41.8839C133.34 41.7457 133.307 41.5492 133.258 41.3011C133.153 40.7721 133.008 40.1847 132.817 39.5534C132.27 37.7519 131.458 35.9504 130.326 34.2648C128.625 31.7337 126.353 29.6947 123.434 28.3369L123.275 28.264C119.982 26.7722 116.002 26.2014 111.288 26.6899L111.212 26.698L111.189 26.6355C110.997 26.1369 110.761 25.5829 110.479 24.9872C109.674 23.2873 108.661 21.5875 107.418 19.9977C105.1 17.0306 102.259 14.7932 98.8465 13.5967L98.7003 13.5462C94.7949 12.2176 90.3471 12.3267 85.3516 14.0968L85.0947 14.1892L85.1153 14.2325C84.8855 13.7402 84.6062 13.1933 84.276 12.6054C83.334 10.9285 82.1695 9.25222 80.7685 7.68526C79.3914 6.14504 77.8555 4.79301 76.1536 3.68278C76.1279 3.66596 76.101 3.65069 76.0733 3.63704L74.5255 2.875L74.4846 2.85634C68.4012 0.289184 62.9652 -0.146085 58.1719 1.23859ZM73.8571 4.20034L75.3399 4.93043L75.3032 4.90619C76.8878 5.93987 78.3248 7.20481 79.6177 8.65092C80.9419 10.132 82.0462 11.7215 82.9387 13.3104C83.2505 13.8655 83.5132 14.38 83.7281 14.8403L83.8312 15.0655C83.8628 15.1358 83.8915 15.2012 83.9174 15.2615L83.9748 15.399C84.1271 15.7841 84.5758 15.9733 84.9706 15.819C90.0806 13.8209 94.5078 13.6441 98.3284 14.9836C101.438 16.0736 104.051 18.1323 106.204 20.8879C107.375 22.3856 108.334 23.9938 109.095 25.6019C109.361 26.164 109.583 26.6851 109.762 27.1512L109.848 27.3795C109.866 27.427 109.882 27.4723 109.898 27.5153L109.967 27.7177C110.077 28.06 110.424 28.2767 110.791 28.2314C115.604 27.6366 119.568 28.175 122.775 29.6665C125.429 30.901 127.495 32.7546 129.05 35.0694C130.095 36.6256 130.849 38.2974 131.356 39.9693L131.408 40.1433C131.509 40.4887 131.595 40.8181 131.666 41.1284L131.713 41.3395H7.85157C1.87384 41.3395 -0.479776 33.8052 4.51442 30.6234C7.96252 28.414 12.5074 27.5073 18.2585 28.2312C18.6109 28.2755 18.9457 28.078 19.0692 27.7594L19.1313 27.5777L19.1772 27.4488C19.2018 27.3809 19.2287 27.308 19.2582 27.2304L19.2884 27.1511C19.4675 26.6853 19.6889 26.1646 19.9544 25.6029C20.7139 23.9959 21.6721 22.3887 22.8415 20.8921C24.992 18.14 27.6045 16.0835 30.714 14.9935C34.5353 13.6541 38.9656 13.8279 44.0817 15.8194C44.4769 15.9733 44.9256 15.783 45.077 15.3973L45.134 15.2599L45.1891 15.1326C45.2284 15.0433 45.2727 14.9452 45.322 14.8388C45.5354 14.3788 45.7965 13.8645 46.1066 13.3096C46.9943 11.7213 48.0936 10.1324 49.4134 8.65184C51.9638 5.79075 55.0182 3.68874 58.607 2.65202C62.9935 1.38482 67.9972 1.76708 73.6803 4.12641L73.8571 4.20034Z"
          fill="#273067"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M86.7165 135.71C89.9391 133.645 94.5319 132.391 100.977 133.203C100.977 133.203 107.346 113.193 126.986 120.838C126.986 120.838 135.131 100.091 156.801 109.235L158.349 109.997C164.642 114.102 167.306 120.838 167.306 120.838C186.921 113.168 193.315 133.203 193.315 133.203C213.209 130.744 215.239 147.78 215.239 147.78H90.4719C83.7477 147.755 81.0834 139.274 86.7165 135.71Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M140.792 106.941C136.9 108.065 133.609 110.33 130.881 113.39C129.484 114.957 128.325 116.633 127.388 118.309L127.291 118.485C127.036 118.948 126.814 119.385 126.623 119.787L126.574 119.892L126.512 119.869C121.37 118.017 116.807 117.91 112.816 119.309C109.403 120.505 106.563 122.74 104.247 125.704C103.006 127.293 101.993 128.992 101.19 130.691L101.107 130.868C100.889 131.338 100.701 131.78 100.54 132.187L100.458 132.399L100.455 132.398C94.6389 131.771 89.9311 132.765 86.296 135.094C80.0374 139.054 82.9848 148.489 90.4685 148.517L215.238 148.517C215.693 148.517 216.046 148.132 215.994 147.694L215.98 147.586C215.96 147.448 215.927 147.251 215.878 147.003C215.773 146.474 215.628 145.887 215.436 145.256C214.89 143.454 214.078 141.653 212.946 139.967C211.245 137.436 208.972 135.397 206.053 134.039L205.895 133.966C202.602 132.474 198.622 131.904 193.908 132.392L193.832 132.4L193.808 132.338C193.616 131.839 193.38 131.285 193.099 130.689C192.294 128.989 191.28 127.29 190.038 125.7C187.72 122.733 184.879 120.495 181.466 119.299L181.32 119.248C177.415 117.92 172.967 118.029 167.971 119.799L167.714 119.891L167.735 119.935C167.505 119.442 167.226 118.895 166.896 118.308C165.954 116.631 164.789 114.954 163.388 113.387C162.011 111.847 160.475 110.495 158.773 109.385C158.748 109.368 158.721 109.353 158.693 109.339L157.145 108.577L157.104 108.558C151.021 105.991 145.585 105.556 140.792 106.941ZM156.477 109.902L157.96 110.633L157.923 110.608C159.507 111.642 160.944 112.907 162.237 114.353C163.562 115.834 164.666 117.424 165.558 119.013C165.87 119.568 166.133 120.082 166.348 120.542L166.451 120.768C166.482 120.838 166.511 120.903 166.537 120.964L166.594 121.101C166.747 121.486 167.195 121.675 167.59 121.521C172.7 119.523 177.127 119.346 180.948 120.686C184.057 121.776 186.671 123.834 188.824 126.59C189.994 128.088 190.954 129.696 191.714 131.304C191.98 131.866 192.202 132.387 192.382 132.853L192.468 133.082C192.486 133.129 192.502 133.174 192.517 133.217L192.587 133.42C192.696 133.762 193.044 133.979 193.41 133.934C198.224 133.339 202.188 133.877 205.394 135.369C208.048 136.603 210.114 138.457 211.669 140.772C212.715 142.328 213.468 144 213.976 145.671L214.027 145.845C214.145 146.248 214.242 146.63 214.32 146.984L214.332 147.041L90.4712 147.042C84.4942 147.02 82.1405 139.485 87.132 136.327C90.5821 134.116 95.127 133.209 100.878 133.933C101.231 133.978 101.565 133.78 101.689 133.462L101.751 133.28L101.797 133.151C101.821 133.083 101.848 133.01 101.878 132.933L101.908 132.853C102.087 132.387 102.309 131.867 102.574 131.305C103.334 129.698 104.292 128.091 105.461 126.594C107.612 123.842 110.224 121.786 113.334 120.696C117.155 119.356 121.585 119.53 126.701 121.522C127.097 121.675 127.545 121.485 127.697 121.099L127.754 120.962L127.809 120.835C127.848 120.745 127.892 120.647 127.942 120.541C128.155 120.081 128.416 119.567 128.726 119.012C129.614 117.423 130.713 115.835 132.033 114.354C134.583 111.493 137.638 109.391 141.227 108.354C145.613 107.087 150.617 107.469 156.3 109.829L156.477 109.902Z"
          fill="#273067"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M143.352 72.9276C146.574 70.8628 151.167 69.6091 157.612 70.4203C157.612 70.4203 163.981 50.4106 183.621 58.0556C183.621 58.0556 191.766 37.3084 213.436 46.4529L214.984 47.2149C221.277 51.3201 223.941 58.0556 223.941 58.0556C243.556 50.386 249.95 70.4203 249.95 70.4203C269.844 67.9621 271.874 84.9974 271.874 84.9974H147.133C140.383 84.9974 137.719 76.5166 143.352 72.9276Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M197.427 44.1585C193.535 45.2829 190.244 47.5475 187.516 50.6077C186.12 52.1745 184.96 53.8506 184.023 55.5273L183.926 55.7024C183.671 56.166 183.449 56.6025 183.258 57.0049L183.209 57.1094L183.148 57.0871C178.005 55.2343 173.442 55.1276 169.451 56.5265C166.038 57.7228 163.199 59.9582 160.883 62.9218C159.641 64.5108 158.628 66.2096 157.825 67.9087L157.742 68.0861C157.524 68.5556 157.336 68.9976 157.176 69.4051L157.094 69.6164L157.09 69.616C151.274 68.9889 146.566 69.9828 142.931 72.312C136.669 76.3021 139.627 85.7343 147.132 85.7343H271.873C272.328 85.7343 272.682 85.3501 272.629 84.9123L272.615 84.8038C272.595 84.6656 272.562 84.4692 272.513 84.2211C272.408 83.692 272.263 83.1046 272.072 82.4733C271.525 80.6718 270.713 78.8703 269.581 77.1847C267.88 74.6536 265.608 72.6146 262.689 71.2568L262.53 71.1839C259.237 69.6921 255.257 69.1213 250.543 69.6098L250.468 69.6179L250.444 69.5555C250.252 69.0568 250.016 68.5028 249.734 67.9071C248.929 66.2072 247.916 64.5075 246.673 62.9177C244.355 59.9506 241.514 57.7131 238.102 56.5166L237.955 56.4661C234.05 55.1376 229.602 55.2466 224.607 57.0167L224.35 57.1091L224.37 57.1524C224.141 56.6601 223.861 56.1132 223.531 55.5253C222.589 53.8484 221.425 52.1721 220.024 50.6052C218.647 49.065 217.111 47.7129 215.409 46.6027C215.383 46.5859 215.356 46.5706 215.328 46.557L213.781 45.7949L213.74 45.7763C207.656 43.2091 202.22 42.7738 197.427 44.1585ZM213.112 47.1202L214.595 47.8503L214.558 47.8261C216.143 48.8598 217.58 50.1247 218.873 51.5708C220.197 53.0519 221.301 54.6414 222.194 56.2303C222.505 56.7854 222.768 57.2999 222.983 57.7602L223.086 57.9854C223.118 58.0557 223.146 58.1211 223.172 58.1814L223.23 58.3189C223.382 58.704 223.831 58.8932 224.225 58.7389C229.336 56.7408 233.763 56.564 237.583 57.9035C240.692 58.9935 243.306 61.0522 245.459 63.8078C246.63 65.3054 247.589 66.9137 248.35 68.5217C248.616 69.0839 248.838 69.6049 249.017 70.0711L249.103 70.2994C249.121 70.3469 249.137 70.3922 249.153 70.4352L249.222 70.6376C249.331 70.9799 249.679 71.1966 250.046 71.1513C254.859 70.5565 258.823 71.0949 262.03 72.5864C264.684 73.8209 266.75 75.6745 268.305 77.9893C269.35 79.5455 270.104 81.2173 270.611 82.8892L270.663 83.0632C270.781 83.4661 270.878 83.8474 270.955 84.2019L270.967 84.2591L147.132 84.2594C141.133 84.2594 138.771 76.7276 143.769 73.5432C147.217 71.3339 151.762 70.4272 157.513 71.1511C157.866 71.1954 158.201 70.9979 158.324 70.6793L158.386 70.4976L158.432 70.3686C158.457 70.3008 158.484 70.2279 158.513 70.1503L158.543 70.071C158.722 69.6052 158.944 69.0845 159.209 68.5228C159.969 66.9158 160.927 65.3086 162.096 63.812C164.247 61.0599 166.859 59.0034 169.969 57.9134C173.79 56.574 178.221 56.7478 183.337 58.7393C183.732 58.8932 184.18 58.7029 184.332 58.3172L184.389 58.1798L184.444 58.0525C184.483 57.9632 184.528 57.8651 184.577 57.7587C184.79 57.2987 185.051 56.7844 185.362 56.2295C186.249 54.6412 187.349 53.0523 188.668 51.5717C191.219 48.7106 194.273 46.6086 197.862 45.5719C202.248 44.3047 207.252 44.687 212.935 47.0463L213.112 47.1202Z"
          fill="#273067"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M170.07 103.04H51.6983C49.2116 103.04 47.1816 101.074 47.1816 98.6645V30.4742C47.1816 28.0652 49.2116 26.0986 51.6983 26.0986H170.07C172.557 26.0986 174.587 28.0652 174.587 30.4742V98.6645C174.587 101.074 172.557 103.04 170.07 103.04Z"
          fill="#005082"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M170.898 27.7533C171.23 27.5038 171.708 27.5624 171.966 27.8843C172.214 28.1938 172.167 28.634 171.868 28.8892L171.831 28.919L113.7 72.5746C112.056 73.8202 109.836 73.84 108.176 72.6357L108.096 72.5765L49.9629 28.919C49.6306 28.6694 49.57 28.2062 49.8276 27.8843C50.0753 27.5748 50.5269 27.5087 50.8567 27.7259L50.8956 27.7533L109.031 71.4127C110.129 72.2441 111.583 72.2607 112.697 71.4608L112.765 71.4108L170.898 27.7533Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.5356 53.8142C84.837 53.5303 85.319 53.5368 85.612 53.8289C85.8934 54.1092 85.8984 54.5507 85.6316 54.8368L85.5969 54.8717L49.0829 89.2618C48.7814 89.5457 48.2995 89.5391 48.0064 89.2471C47.7251 88.9668 47.7201 88.5253 47.9869 88.2392L48.0216 88.2043L84.5356 53.8142Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M136.487 53.8289C136.768 53.5485 137.224 53.5312 137.526 53.7815L137.563 53.8142L174.077 88.2043C174.379 88.4882 174.386 88.9551 174.092 89.2471C173.811 89.5275 173.356 89.5447 173.053 89.2945L173.016 89.2618L136.502 54.8717C136.201 54.5878 136.194 54.1209 136.487 53.8289Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M170.528 142.839C190.162 142.839 206.078 127.42 206.078 108.399C206.078 89.379 190.162 73.96 170.528 73.96C150.895 73.96 134.979 89.379 134.979 108.399C134.979 127.42 150.895 142.839 170.528 142.839Z"
          fill="#FFD4BA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M198.515 75.5577C197.044 74.6727 195.09 75.1152 194.176 76.541L186.412 88.6353C181.794 85.0217 175.932 82.8585 169.563 82.8585C154.744 82.8585 142.691 94.5349 142.691 108.891C142.691 123.247 154.744 134.923 169.563 134.923C184.382 134.923 196.435 123.247 196.435 108.891C196.435 102.967 194.379 97.5094 190.928 93.1092L199.505 79.7366C200.444 78.3109 199.987 76.4426 198.515 75.5577ZM194.455 108.891C194.455 122.19 183.291 133.006 169.563 133.006C155.835 133.006 144.671 122.19 144.671 108.891C144.671 95.5922 155.835 84.7761 169.563 84.7761C175.551 84.7761 181.058 86.841 185.346 90.2579L171.289 112.16L163.143 101.664C162.103 100.312 160.124 100.042 158.728 101.049C157.333 102.057 157.053 103.975 158.094 105.327L169.005 119.387C169.614 120.15 170.527 120.617 171.517 120.617C171.568 120.617 171.618 120.617 171.644 120.617C172.684 120.567 173.623 120.027 174.181 119.191L189.787 94.9039C192.73 98.837 194.455 103.68 194.455 108.891Z"
          fill="#FFB039"
        />
      </svg>

      <h5 class="heading-h5 title">
        Tu nueva plantilla ha sido solicitada a Securitec
      </h5>
      <p class="body-2 description">
        Tu solicitud ha sido enviada y pasará por el proceso de revisión. El
        tiempo máximo es de 1.5 a 2 semanas. ¡Gracias!
      </p>
    </div>
  </div>
</template>

<script>
import Phone from '@/app/shared/components/phones/Phone.vue'
import { mapActions, mapGetters } from 'vuex'
import transformWordGender from '@/app/shared/mixins/transform'
import CustomSectionScroll from '@/app/shared/components/sections/CustomSectionScroll'

export default {
  name: 'StepsNewTemplate',
  props: {
    dataChannel: {
      type: Object,
      required: true,
    },
  },
  components: {
    Phone,
    CustomSectionScroll,
  },
  data: () => ({
    app: process.env.VUE_APP_NAME,
    current: 0,
    steps: [
      { title: 'one', content: '' },
      { title: 'second', content: '' },
      { title: 'third', content: '' },
      { title: 'four', content: '' },
      { title: 'five', content: '' },
    ],
    params: [],
    message: '',
    matchRegex: [],
    newTemplate: {
      name: '',
      friendlyName: '',
      body: null,
      lang: undefined,
      category: undefined,
      parameters: [],
    },
    saveLoading: false,
    nameButtonAdd: 'Siguiente',
    loadButton: false,
    categories: ['TRANSACTIONAL', 'MARKETING', 'OTP'],
    sent: false, // true si fue enviado, falso si no ha sido enviado
    validating: false, // si esta siendo validado
    sending: false, // se esta enviando
  }),
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'steps-new-template' })
  },
  mixins: [transformWordGender],
  computed: {
    ...mapGetters(['company', 'profile']),
    // titulo segun el paso en que este
    title() {
      switch (this.current) {
        case 0: {
          if (this.dataChannel.request)
            return '¡Empecemos! Agrega un nombre a tu plantilla'
          else return '¡Empecemos! Agrega el nombre de tu plantilla'
        }
        case 1: {
          return 'Ahora agrega el nombre de visualización'
        }
        case 2: {
          return 'Selecciona el idioma y la categoría'
        }
        case 3: {
          return 'Crea el contenido de tu plantilla'
        }
        case 4: {
          return 'Luego completa los parámetros'
        }
        case 5: {
          return 'Finalmente ponle nombres'
        }
      }
      return 'Titulo'
    },
    nameButton() {
      if (this.current === 3) {
        if (this.params.length) return 'Continuar'
        else if (this.validating) return 'Validando plantilla'
        else return 'Continuar'
      } else {
        return 'Continuar'
      }
    },
    descriptionFirstStep() {
      if (this.dataChannel.request)
        return 'El nombre debe ser en minúsculas, separados por un guión bajo, sin espacios y sin caracteres especiales. Ejemplo: recordatorio_de_pago'
      else
        return 'Recuerda que tu plantilla debe ser aprobada previamente por tu proveedor (Twilio).'
    },
    descriptionFourStep() {
      return (
        'Puedes añadir parámetros escribiendo {{}} y colocando un número que indique el orden.' +
        '\n' +
        'Por ejemplo: Hola {{1}}, gracias por contactarnos por {{2}}'
      )
    },
  },
  methods: {
    ...mapActions(['createTemplate', 'validateTemplate']),
    // para ir hacia adelante
    next() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.name) {
            this.current++
            this.newTemplate.name = values.name.trim()
          } else if (values.friendlyName) {
            this.newTemplate.friendlyName = values.friendlyName.trim()
            this.current++
          } else if (values.category) {
            this.newTemplate.category = values.category.trim()
            this.newTemplate.lang = values.lang.trim()
            this.current++
          } else if (values.content) {
            this.newTemplate.body = values.content
              .trim()
              .replace(/\n/g, '</br>') // Para controlar los saltos de línea
            // si el contenido no tiene parametros
            if (this.params.length === 0) {
              this.openModalWarning(this.dataChannel.request)
            } else {
              // si tiene menos o igual a  10 parametros
              const noConsecutives = []
              if (this.params.length <= 10) {
                this.params.map((item, index) => {
                  const regex = /{{|}}/gm
                  let number = item.title.replace(regex, '')
                  let order = index + 1
                  if (number === order.toString()) console.log('es consecutivo')
                  else noConsecutives.push(number)
                })
                if (noConsecutives.length)
                  this.$message.error(
                    'Los parámetros deben comenzar desde el orden 1 y deben ser consecutivos'
                  )
                else this.current++
              } else
                this.$message.error('El contenido tiene más de 10 parámetros')
            }
          }
          setTimeout(() => {
            const fieldsValues = this.getFieldsValue()
            const arrProperties = Object.keys(fieldsValues)
            arrProperties.map((property) => this.setValue(property))
          }, 100)
        }
      })
    },
    // para ir hacia atras
    prev() {
      this.current--
      // para content
      this.newTemplate.body = this.message
      setTimeout(() => {
        const fieldsValues = this.getFieldsValue()
        const arrProperties = Object.keys(fieldsValues)
        arrProperties.map((property) => this.setValue(property))
      }, 100)
    },
    // validar si la plantilla ya fue aprobada
    async validate() {
      this.$message.loading({
        content: `Verificando si la plantilla de ${this.dataChannel.supplier} está activa`,
        key: 'validate',
        duration: 16,
      })
      this.validating = true
      const template = this.newTemplate
      template.save = true
      const response = await this.validateTemplate({
        template,
        companyChannelId: this.dataChannel._id,
      })
      // si fue exitosoo / si estaba registrado en su proveedor
      if (response.result === 'verified') {
        this.$message.success({
          content: 'Tu plantilla ha sido validada con éxito',
          key: 'validate',
          duration: 2,
        })
        this.onClose()
      } else if (response.result === 'duplicated') {
        this.$message.error({
          content: 'El nombre de esta plantilla ya existe',
          key: 'validate',
          duration: 2,
        })
      } else if (response.result === 'no-verified') {
        this.$message.error({
          content:
            'La plantilla no pudo ser verificada como activa, verifica los datos ingresados.',
          key: 'validate',
          duration: 2,
        })
      } else if (response.result == 'gupshup partner fail') {
        this.$message.error({
          content:
            'No podemos verificar la plantilla porqué no es un partner de Gupshup.',
          key: 'validate',
          duration: 2,
        })
      } else {
        // no estaba registrado en su proveedor
        this.$message.error({
          content:
            'La plantilla no pudo ser verificada como activa, verifica los datos ingresados.',
          key: 'validate',
          duration: 2,
        })
      }
      this.validating = false
    },
    // se ejecuta cuando escribe en el textarea
    typingContent(e) {
      this.message = e.target.value
      // extrae los parametros
      // verifica si son numeros consecutivos
      //
      this.extractParams(this.message)
      this.params = []

      if (this.matchRegex) {
        this.matchRegex.map((item) => {
          const obj = { title: item }
          this.params.push(obj)
        })
      }
    },
    // extraer los parametros del contenido de la plantilla
    extractParams(content) {
      const regex = /{{([0-9]|[0-9][0-9]|[1-9]0)}}/gm
      const found = content.match(regex)
      this.matchRegex = found
    },
    // elimina los elementos repetidos
    deleteRepeated(arr) {
      if (!arr) return []
      return arr.filter((item, index, array) => {
        return array.indexOf(item) === index
      })
    },
    openModalWarning(request) {
      const wordSure = this.profile.gender
        ? this.transformWordGender('seguro', this.profile.gender)
        : 'segur@'
      // con parametros
      if (this.params.length) {
        this.form.validateFields((err, values) => {
          if (!err) {
            const arrValues = Object.keys(values).map((value) => {
              const param = values[value]
              return param
            })
            const params = JSON.parse(JSON.stringify(this.params))

            this.newTemplate.parameters = params.map((item, index) => {
              item.title = `${item.title} ${arrValues[index]}`
              return item
            })

            if (request)
              this.modalConfirm(
                `¿Estás ${wordSure} de solicitar esta nueva plantilla a Securitec?`,
                'Recuerda que una vez solicitada la plantilla, no podrás suspender el proceso ni editarla posteriormente, a excepción del nombre de visualización.',
                request,
                'Solicitar'
              )
            else
              this.modalConfirm(
                `¿Estás ${wordSure} de validar esta nueva plantilla de ${this.dataChannel.supplier}?`,
                'Se verificará que esta plantilla haya sido aprobada previamente por su proveedor.',
                request,
                'Validar'
              )
          }
        })
      } else {
        // sin parametros
        if (request) {
          this.modalConfirm(
            '¿Estás segur@ de solicitar esta nueva plantilla a Securitec?',
            'Recuerda que una vez solicitada la plantilla, no podrás editarla ni suspender el proceso.',
            request,
            'Solicitar'
          )
        } else {
          this.modalConfirm(
            `¿Estás segur@ de validar esta nueva plantilla de ${this.dataChannel.supplier}?`,
            'Se verificará que esta plantilla haya sido aprobada previamente por su proveedor.',
            request,
            'Validar'
          )
        }
      }
    },
    onClose() {
      this.$emit('onCancel')
      this.newTemplate = {
        name: '',
        friendlyName: '',
        body: '',
        parameters: [],
        category: undefined,
        lang: undefined,
      }
      this.params = []
      this.current = 0
    },
    // crea la plantilla y la guarda en la bd, sirve para los dos casos: solicitar, registrar
    async registerTemplate() {
      this.sending = true
      this.$message.loading({
        content: `Solicitando plantilla...`,
        key: 'register',
        duration: 16,
      })
      this.newTemplate.channelId = this.$route.query.channelId
      const response = await this.createTemplate(this.newTemplate)
      if (response.success) {
        this.$message.success({
          content: `Plantilla registrada exitosamente`,
          key: 'register',
          duration: 3,
        })
        this.sent = true // se muestra el contenido de enviado
        this.$emit('onCreate')
        this.newTemplate = {
          name: '',
          friendlyName: '',
          body: '',
          lang: undefined,
          category: undefined,
          parameters: [],
        }
        this.params = []
        this.current = 0
        this.form.resetFields()
      } else {
        this.$message.error({
          content:
            response.details || `Ocurrió un error al registrar la plantilla`,
          key: 'register',
          duration: 2,
        })
      }
      this.sending = false // ya se termino de enviar
    },
    getFieldsValue() {
      const values = this.form.getFieldsValue()
      return values
    },
    setValue(property) {
      this.form.setFieldsValue({
        [property]:
          this.newTemplate[property === 'content' ? 'body' : property],
      })
    },
    /**Modal de confirmacion
     * @param {String} title titulo del modal
     * @param {String} content descripcion del modal
     */
    modalConfirm(title, content, request, okText) {
      const self = this
      this.$confirm({
        title: title,
        content: content,
        okText: okText,
        cancelText: 'Volver',
        centered: true,
        onOk() {
          // si es para solcitar plantilla
          if (request) {
            self.registerTemplate()
            self.destroyAll()
          }
          // si es para registrar plantilla
          else {
            self.validate()
          }
        },
        class: 'test',
      })
    },
    // destruye el modal de confirmación
    destroyAll() {
      this.$destroyAll()
    },
    resetForm() {
      this.form.resetFields()
      this.newTemplate = {
        name: '',
        friendlyName: '',
        body: '',
        parameters: [],
        category: undefined,
        lang: undefined,
      }
      this.params = []
      this.current = 0
      this.message = ''
      this.matchRegex = []
      this.sent = false
      this.validating = false
    },
  },
}
</script>

<style lang="sass" scoped>
.steps
  width: 32px
.ant-steps-item
  height: 88px

.steps-new-template
  &-content
    display: flex
    flex-direction: row
    height: 450px
    position: relative
    .steps-content
      margin-left: 32px
      .content
        width: 296px
      .steps-action
        position: absolute
        bottom: 0
.contain-sent
  height: 450px
  padding: 16px
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  .title
    text-align: center
    color: $gray_dark_900
    margin-top: 32px
  .description
    text-align: center
    color: $gray_dark_800
    margin-bottom: 12px
</style>
